import { DateField, TextField } from "react-admin";

import Card from "./Card";
import EditButton from "../components/buttons/EditButton";
import Filters from "./Filters";
import GroupsField from "./fields/GroupsField";
import LoginButton from "./buttons/LoginButton";
import React from "react";
import ResponsiveGridWithWebsocket from "../components/list/ResponsiveGridWithWebsocket";
import ResponsiveList from "../components/list/ResponsiveList";
import { useRowHighlightTracking } from "../components/utils/useRowHighlightTracking";

const List = (props) => {
  const { user: highlightedUserIds = [] } = useRowHighlightTracking();

  const rowClass = (record) => {
    const id = record.id?.toString();
    if (highlightedUserIds.includes(id)) return "modifyResource";
    return "";
  };

  return (
    <ResponsiveList
      {...props}
      type="table"
      split
      filters={<Filters />}
      key={highlightedUserIds.join(",")}
    >
      <ResponsiveGridWithWebsocket
        rowBreakpoint="md"
        cardContent={<Card />}
        rowClasses={rowClass}
        target="user"
      >
        <TextField source="id" />
        <GroupsField source="groups" />
        <TextField source="auth_type" variant="body2" />
        <TextField source="username" />
        <DateField source="created" showTime />
        <DateField source="modified" showTime />
        <LoginButton />
        <EditButton />
      </ResponsiveGridWithWebsocket>
    </ResponsiveList>
  );
};
export default List;
